/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Joined_ColInputs */

const en_admin_users_joined_col = /** @type {(inputs: Admin_Users_Joined_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined`)
};

/**
* | output |
* | --- |
* | "Joined" |
*
* @param {Admin_Users_Joined_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_joined_col = /** @type {((inputs?: Admin_Users_Joined_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Joined_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_joined_col(inputs)
});
export { admin_users_joined_col as "admin.users.joined_col" }